import { PrimaryButton } from '@/components/button/button-component';
import propTypes from 'prop-types';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import { emailRegex } from '@/utils/validations';
import { MdOutlineEmail } from 'react-icons/md';
import styled from 'styled-components';

/**
 * Complete Forgot Password form
 * @param {object} props - The props
 * @param {boolean} props.loading - The loading state
 * @returns {JSX.Element}
 */
const ForgotPasswordForm = ({ loading }) => (
  <Container>
    <Input
      label="Email Address"
      placeholder="email"
      iconLeft={<MdOutlineEmail />}
      name="email"
      disabled={loading}
      registerOptions={{
        validate: (value) => {
          let errorMessage = null;
          emailRegex.forEach((rule) => {
            if (!rule.pattern.test(value)) {
              errorMessage = rule.message;
            }
          });
          return errorMessage || true;
        },
      }}
    />
    <PrimaryButton
      buttonWidth="100%"
      buttonHeight="48px"
      type="submit"
      loading={loading}
      title="SEND RESET EMAIL"
    />
  </Container>
);

const Container = styled.div`
  display: flex;
  min-width: 420px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
`;

ForgotPasswordForm.propTypes = {
  loading: propTypes.bool.isRequired,
};

export default ForgotPasswordForm;
